import React from 'react';
import { SubImagesProps } from './types';
import ImageItem from './components/ListingImageItem';
import Classes from './ListingFigureSubImages.module.scss';

const SubImages: React.FC<SubImagesProps> = ({
  images,
  fetchPriority,
  loadingType,
  decodingType,
  aspectRatio,
  enableLandscapeContain = false,
}) => (
  <div className={Classes['hz-Listing-sub-images']}>
    <ImageItem
      image={images[1]}
      fetchPriority={fetchPriority}
      loadingType={loadingType}
      decodingType={decodingType}
      aspectRatio={aspectRatio}
      enableLandscapeContain={enableLandscapeContain}
    />
    <ImageItem
      image={images[2]}
      fetchPriority={fetchPriority}
      loadingType={loadingType}
      decodingType={decodingType}
      aspectRatio={aspectRatio}
      enableLandscapeContain={enableLandscapeContain}
    />
  </div>
);

export default SubImages;
